import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from './../../../utilities/LanguageContext'

//Componentes comunes generales
// import { Header } from './../../Header/Header'
import { Header } from './../../Header/V2/Header'
import { Loading } from './../../Common/Loading'
import { LogErrors } from './../../../utilities/LogErrors'
import { ValidateSession } from './../../../utilities/BL/Sessions'
import { GoToTop } from './../../Common/GoToTop'
import { GoToBack } from './../../Common/GoToBack'

import { CourseData } from './../CourseData'
import { GetDataFromTheChosenCourse, GetItemResult, ResetItemsViewData, SaveInstrumentToShowOfResultView } from './../../../utilities/BL/Student/Results'
import { AccreditationQuestionBlock } from './../Items/AccreditationQuestionBlock'
import { Credits } from './../../Common/Credits/Credits'
import { WEBPAGES } from './../../../utilities/EL/WebPages'
import { TYPE_PROPOSITION_VALUE } from './../../../utilities/EL/TypePropositionValue'
import { ROLES } from './../../../utilities/EL/Roles'
import { HELP_TYPE } from '../../../utilities/EL/HelpType'
import { BodyWithSideMenu } from './../../Dashboard/BodyWithSideMenu'


//Agregar multiidioma


const Items = () => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()

    const [session, setSession] = useState({})
    const [theme, setTheme] = useState(null)

    const [isLoading, setIsLoading] = useState(true)
    const [result, setResult] = useState(null)

    const [activeFilter, setActiveFilter] = useState('all') // 'all', 'correct', 'incorrect'

    const [isAccreditation, setIsAccreditation] = useState(null)
    const [totalTasks, setTotalTasks] = useState(null)
    const [correctTasks, setCorrectTasks] = useState(null)
    const [incorrectTasks, setIncorrectTasks] = useState(null)

    const [courseName, setCourseName] = useState(null)


    const GoToViewer = async (task) => {
        try {
            const response = await SaveInstrumentToShowOfResultView(session, result, task)

            if (response.success) {
                navigate('/viewer')
            } else {
                console.log(response.message)
            }
        } catch (error) {
            await LogErrors('GoToViewer Items', error)
        }
    }

    const renderQuestions = () => {
        const filteredQuestions = result.questions
            .map((question, originalIndex) => {
                const tasksFiltered = question?.tasks?.filter((task) => {
                    if (activeFilter === 'correct') return task.result === 1
                    if (activeFilter === 'incorrect') return task.result === 0
                    return true
                })

                if (!tasksFiltered || tasksFiltered.length === 0) return null

                return {
                    ...question,
                    tasks: tasksFiltered,
                    originalIndex,
                }
            })
            .filter(Boolean)

        if (filteredQuestions.length === 0) {
            return <p className="Result__Text">Sin resultados.</p>
        }

        return filteredQuestions.map((filteredQuestion, i) =>
            isAccreditation ? (
                <AccreditationQuestionBlock key={i} index={filteredQuestion.originalIndex} question={filteredQuestion} GoToViewer={GoToViewer} />
            ) : (
                <div key={i} className={`Result__Question ${filteredQuestion.tasks[0].result === 0
                    ? 'Result__Question--Bad'
                    : 'Result__Question--Good'
                    }`}
                >
                    <div className="Result__Question__Detail">
                        <p dangerouslySetInnerHTML={{ __html: filteredQuestion.tasks[0].instruction }} />
                        {filteredQuestion.tasks[0].result === 0 ? (
                            <p className="Result__Question__Detail--Bad">{filteredQuestion.tasks[0].analysis}</p>
                        ) : (
                            <p className="Result__Question__Detail--Good">¡Correcto!</p>
                        )}
                    </div>
                    {filteredQuestion.tasks[0].result === 0 && (
                        <button type="button" className="Result__Question__Buttons--Bad" onClick={() => GoToViewer(filteredQuestion.tasks[0])}>Ir al tema</button>
                    )}
                </div>
            )
        )
    }

    const LoadPage = async (sessionInfo) => {
        try {
            setTheme(sessionInfo.user.userTheme)

            document.body.classList.add('BodyComplete')


            const response = await GetItemResult(sessionInfo)

            if (response.success) {
                setResult(response.data)

                const tmpIsAccreditation = response.data.questions.some(q => q.tasks.length > 1)
                setIsAccreditation(tmpIsAccreditation)
                const tmpTotalTasks = response.data.questions.reduce((sum, q) => sum + q.tasks.length, 0)
                setTotalTasks(tmpTotalTasks)
                const tmpCorrectTasks = response.data.questions.reduce((sum, q) => sum + q.tasks.filter(t => t.result === 1).length, 0)
                setCorrectTasks(tmpCorrectTasks)
                const tmpIncorrectTasks = tmpTotalTasks - tmpCorrectTasks
                setIncorrectTasks(tmpIncorrectTasks)

                await GetDataCourse(sessionInfo, response.data.idCourse)
            } else {
                console.log(response.message)
            }


            const responseData = await ResetItemsViewData(sessionInfo)

            if (responseData.success) {
                setSession(responseData.data)
            } else {
                setSession(sessionInfo)
            }
        } catch (error) {
            await LogErrors('LoadPage Items', error)
        } finally {
            setIsLoading(false)
        }
    }

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        async function Validate() {
            const tmpSession = await ValidateSession()

            if (tmpSession.success) {
                if (tmpSession.data.user.userStatus === 2) {
                    await LoadPage(tmpSession.data)
                } else {
                    navigate('/confirm')
                }
            } else {
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        }
        Validate()
    }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar

    const GetDataCourse = async (sessionInfo, idEvaluation) => {
        try {
            if (sessionInfo && idEvaluation) {
                const response = await GetDataFromTheChosenCourse(sessionInfo, idEvaluation)

                if (response.success) {
                    const courseData = `${response.data.name} nivel ${response.data.level === 1 ? translate('labels.course.levels.one') : translate('labels.course.levels.two')} ${response.data.type === 1 ? translate('labels.dashboard.tiles.examType.certification') : translate('labels.dashboard.tiles.examType.custom')}`
                    setCourseName(courseData)
                }
            }
        } catch (error) {

        }
    }


    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <BodyWithSideMenu page={WEBPAGES.ZTUDENT.RESULTS_ITEMS} theme={theme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.RESULTS_ITEMS} role={ROLES.ZTUDENT}>
                        {/* <Header theme={theme} /> */}
                        <Header theme={theme} setTheme={setTheme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.RESULTS_ITEMS} />

                        <main className='container Result Container-FullHeight'>
                            <GoToBack url={'/results'} />

                            {result ? (
                                <div>
                                    <div className='Result__Box Tables--Shadow'>
                                        <p className="Result__Box__Title">Resultado de: {result.name}</p>
                                        <CourseData idEvaluation={result.idCourse} className="CourseData Result__Box__Info" />

                                        {result.reviewcompleted ? (
                                            <>
                                                <p className="Result__Box__Info">{`Resultado: ${result.score}`}</p>
                                                <p className="Result__Box__Info">{`Total de preguntas: ${result.totalQuestions}`}</p>
                                                {isAccreditation ? (
                                                    <>
                                                        <p className="Result__Box__Info">{`Total de tareas solicitadas: ${result.totalQuestions * 3}`}</p> {/* Temporalmente se hace una multiplicación. En cuanto se tenga la propiedad, se cambiaría aquí */}
                                                        <p className="Result__Box__Info">{`Tareas correctas: ${correctTasks}`}</p>
                                                        <p className="Result__Box__Info Last-Child">{`Tareas incorrectas: ${incorrectTasks}`}</p>
                                                    </>
                                                ) : (
                                                    <>
                                                        <p className="Result__Box__Info">{`Preguntas correctas: ${result.correct}`}</p>
                                                        <p className="Result__Box__Info Last-Child">{`Preguntas incorrectas: ${result.incorrect}`}</p>
                                                    </>
                                                )}

                                                {/* {result.score = 1000 ? (
                                                    <div className='Result__Box__Info--Highlight'>
                                                        <p className="Result__Box__Info">¡Dominaste la evaluación {result.name} de {courseName}! Ahora que lograste con el puntaje máximo, ¿qué fue lo que marcó la diferencia en tu forma de resolver?</p>
                                                    </div>
                                                ) : (result.score < 1000 && result.score >= 800) ? (
                                                    <div className='Result__Box__Info--Highlight'>
                                                        <p className="Result__Box__Info">Ahora que aprobaste tu evaluación {result.name} de {courseName}, ¿en qué situación de tu vida o trabajo podrías aplicar esto que acabas de aprender?</p>
                                                    </div>
                                                ) : (
                                                    <div className='Result__Box__Info--Highlight'>
                                                        <p className="Result__Box__Info">Aplicaste la evaluación {result.name} de {courseName}, la calificación no alcanzó el mínimo requerido para aprobar, pero aún hay oportunidad de reforzar lo aprendido.</p>
                                                        <p className="Result__Box__Info">¿Qué parte del bloque se sintió más difícil de llevar a la práctica?</p>
                                                    </div>
                                                )} */}

                                                {/* Reemplaza tu bloque condicional de result.score por este: */}

                                                {Number(result.score) === 1000 ? (
                                                    <div className='Result__Box__Info--Highlight'>
                                                        <p className="Result__Box__Info">¡Dominaste la evaluación {result.name} de {courseName}! Ahora que lograste con el puntaje máximo, ¿qué fue lo que marcó la diferencia en tu forma de resolver?</p>
                                                    </div>
                                                ) : (Number(result.score) < 1000 && Number(result.score) >= 800) ? (
                                                    <div className='Result__Box__Info--Highlight'>
                                                        <p className="Result__Box__Info">Ahora que aprobaste tu evaluación {result.name} de {courseName}, ¿en qué situación de tu vida o trabajo podrías aplicar esto que acabas de aprender?</p>
                                                    </div>
                                                ) : (
                                                    <div className='Result__Box__Info--Highlight'>
                                                        <p className="Result__Box__Info">Aplicaste la evaluación {result.name} de {courseName}, la calificación no alcanzó el mínimo requerido para aprobar, pero aún hay oportunidad de reforzar lo aprendido.</p>
                                                        <p className="Result__Box__Info">¿Qué parte del bloque se sintió más difícil de llevar a la práctica?</p>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <p className='Result__Box__Info mt-5 text-danger fs-1'><i className="bi bi-list-check"></i></p>
                                                <p className='Result__Box__Info text-danger'>La mente maestra está revisando tu evaluación en nuestro laboratorio.</p>
                                                <p className='Result__Box__Info mb-5 text-danger'>Consulta tu resultado más tarde.</p>
                                            </>
                                        )}
                                    </div>

                                    {result.reviewcompleted && (
                                        <>
                                            <p className='Result__Title Result__Divisor'>{isAccreditation ? 'Preguntas y tareas del examen' : 'Preguntas del examen'}</p>

                                            <div className='Result__Filter'>
                                                <button type='button' className={`Result__Filter__Buttons ${activeFilter === 'all' ? 'Result__Filter__Buttons--Active' : ''}`} onClick={() => setActiveFilter('all')}>Todas ({isAccreditation ? totalTasks : result.totalQuestions})</button>
                                                <button type='button' className={`Result__Filter__Buttons ${activeFilter === 'correct' ? 'Result__Filter__Buttons--Active' : ''}`} onClick={() => setActiveFilter('correct')}>Correctas ({isAccreditation ? correctTasks : result.correct})</button>
                                                <button type='button' className={`Result__Filter__Buttons ${activeFilter === 'incorrect' ? 'Result__Filter__Buttons--Active' : ''}`} onClick={() => setActiveFilter('incorrect')}>Incorrectas ({isAccreditation ? incorrectTasks : result.incorrect})</button>
                                            </div>

                                            {renderQuestions()}

                                            {/* {result.questions ? (
                                            ) : (
                                                <p className='Result__Text'>Por el momento tu evaluación está en proceso de revisión. Actualiza la página web o intenta actualizarla más tarde.</p>
                                            )} */}
                                        </>
                                    )}
                                </div>
                            ) : (
                                <p className='Result__Text'>No se pudieron obtener los resultados de tu evaluación. Inténtalo nuevamente o más tarde.</p>
                            )}
                        </main>
                    </BodyWithSideMenu>
                </>
            )}
        </>
    )
}

export { Items };